var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBambooIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.475 70.5c-6.45 0-11.925-5.1-11.925-11.9 0-6.825 4.6-12.425 12.025-12.425 7.425 0 11.8 6 11.8 12.3.025 6.85-4.625 12.025-11.9 12.025zm-19.05-22.575L37.15 40.45c-1.35-3.925-1.775-6.2-5.6-10.25-1.325-1.4-6.3-4.45-5.675-3.775 6.3 6.8 9.525 15.05 10.775 17.35-1.15-1.375-2.475-2.625-4-4.175-1.3-1.325-2.65-2.5-3.95-3.3-.85-.525-1.325-.825-2.2-1.25-3.875-2.025-7.65-3.25-9.1-3.6-1.775-.45-3.5-.55-3.5-.55s5.625 4.75 8.05 7.775c2.4 3.025 4.875 5.725 7.6 6.85 2.725 1.1 3.675 1.425 5.8 1.75 1.825.225 4.075.65 4.075.65zm19.55-6.625c-5.95 0-9.15 2.05-11.375 4.275l-.6.65v-19.95h-5.15v32.65c0 10.05 7.725 16.3 16.625 16.3 9.775 0 17.175-7.525 17.175-17.2 0-9-7.725-16.725-16.675-16.725zM100 50c0 27.625-22.375 50-50 50S0 77.625 0 50 22.375 0 50 0s50 22.375 50 50z",
    fill: "#73C41D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBambooIcon);
export default __webpack_public_path__ + "static/media/bamboo-icon.314960d1dddc561e5b0d1185a9f9d985.svg";
export { ForwardRef as ReactComponent };